import React from 'react';
import useToggleContext, { ToggleContextProvider } from '~/components/toggle/toggle-context';
export function useRefToFocusAfterClose() {
    const { isOpen } = useToggleContext();
    const [hasBeenOpened, setHasBeenOpened] = React.useState(false);
    const ref = React.useRef(null);
    React.useEffect(() => {
        var _a;
        if (isOpen) {
            setHasBeenOpened(true);
        }
        else if (hasBeenOpened) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [isOpen, hasBeenOpened]);
    return ref;
}
export function IfToggleIsOpen({ children }) {
    const { isOpen } = useToggleContext();
    return isOpen && children;
}
export default function Toggle({ children }) {
    return React.createElement(ToggleContextProvider, null, children);
}
